import i18n from 'i18next';
import {initReactI18next} from 'react-i18next';

import en from './en/en.json';
import Japanese from './jpn/Japanese.json';

const resources = {
  en: {
    translation:en
  },
  jpn: {
    translation: Japanese
  }
};

i18n.use(initReactI18next).init({
  resources,
  lng: 'en',
  fallbackLng: 'en',
  interpolation: {}
}).catch(()=> {});

export default i18n;


